import { useCallback } from 'react';
import { CardValidationError } from '../../../constants';
import { Psd2AuthData } from '../usePaymentMethodsQuery';
import { createForm } from './createForm';
import { getContainerElement } from './getContainerElement';

export const useRedirectShopper = () => {
  const redirectShopper = useCallback(
    (psd2AuthData?: Psd2AuthData | null) =>
      new Promise((resolve, reject) => {
        if (!psd2AuthData)
          return reject(new CardValidationError('redirectShopper: psd2AuthData missing'));

        const { issuerUrl, md, paRequest, termUrl } = psd2AuthData;

        const container = getContainerElement();
        const form = createForm(issuerUrl, { PaReq: paRequest, MD: md, TermUrl: termUrl });

        container.appendChild(form);
        form.submit();
        container.removeChild(form);
      }),
    []
  );

  return redirectShopper;
};
